<template>
	<v-row v-if="isVisible" class="mb-4">
		<v-col cols="12">
			<v-alert
				type="warning"
				variant="tonal"
				:closable="false"
				class="my-2 text-start"
			>
				<div class="d-flex align-center justify-space-between flex-wrap gap-2">
					<span>{{ displayMessage }}</span>
					<v-btn
						color="warning"
						variant="tonal"
						prepend-icon="mdi-refresh"
						size="small"
						@click="reload"
					>
						Refresh Page
					</v-btn>
				</div>
			</v-alert>
		</v-col>
	</v-row>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';

const DEFAULT_MESSAGE =
	'A network interruption was detected. Progress updates may have stopped. ' +
	'Please refresh the page to continue.';

const props = withDefaults(defineProps<{
	message?: string;
}>(), {
	message: DEFAULT_MESSAGE,
});

const isVisible = ref(false);
const wentOffline = ref(false);

const displayMessage = computed(() => props.message);

const reload = () => {
	window.location.reload();
};

const trigger = () => {
	isVisible.value = true;
};

const handleOffline = () => {
	wentOffline.value = true;
	trigger();
};

const handleOnline = () => {
	if (wentOffline.value) {
		// Network interface changed — SignalR socket is dead even though
		// connectivity is restored. A full reload is required.
		trigger();
	}
};

onMounted(() => {
	window.addEventListener('offline', handleOffline);
	window.addEventListener('online', handleOnline);
});

onUnmounted(() => {
	window.removeEventListener('offline', handleOffline);
	window.removeEventListener('online', handleOnline);
});
</script>
